import { Link } from 'react-router-dom';
import AltaVehiculo from '@/pages/administracion/vehiculos/AltaVehiculo.jsx';
import { Button } from '@/components/ui/button.jsx';
import AdminPageHeader from '../ui/AdminPageHeader.jsx';

export default function AltaVehiculoWrapper() {
  return (
    <div className="space-y-4">
      <AdminPageHeader
        title="Alta de vehículo"
        breadcrumbs={[
          { label: 'Administración', href: '/admin' },
          { label: 'Vehículos', href: '/admin/vehiculos' },
          { label: 'Nuevo' },
        ]}
        action={
          <Button variant="outline" asChild>
            <Link to="/admin/vehiculos">Volver a vehículos</Link>
          </Button>
        }
      />

      <div className="rounded-3xl border border-slate-200/80 bg-white/90 p-4 shadow-sm dark:border-slate-800/70 dark:bg-slate-900/50">
        <AltaVehiculo />
      </div>
    </div>
  );
}
